module.exports = __webpack_public_path__ + "static/img/contact_logo6.37b2fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo6.png
// module id = 4nsY
// module chunks = 1